const config = {
  mid: 'PP20211005-ZXC4E',
  apiKey: 'GIVEN_API_KEY_FROM_PUBL_PAY',
  secretKey: 'GIVEN_SECRET_KEY_FROM_PUBL_PAY'
};

export default config;
